module.exports = __webpack_public_path__ + "img/icon-settings-white.54a1c0ef.svg";